import React from 'react';

import classNames from 'classnames';
import Icon from 'components/icons';
import PropTypes from 'prop-types';

import './NavigationCard.scss';

const renderImage = (image) =>
  image && <img className="navigation-card__image" src={image} alt="" />;

const renderIcon = (icon) =>
  icon && (
    <Icon
      {...icon}
      className="navigation-card__icon"
      data-test="card-header-icon"
    />
  );

const NavigationCard = ({ image, icon, title, description, onClick, last }) => (
  <button
    className={classNames('navigation-card', { '-last': last })}
    onClick={onClick}
    data-test="navigation-link"
  >
    <div className="navigation-card__text-container">
      <h3 className="navigation-card__title">{title}</h3>
      <p className="navigation-card__description">{description}</p>
    </div>
    {renderImage(image)}
    {renderIcon(icon)}
  </button>
);

NavigationCard.propTypes = {
  image: PropTypes.string,
  icon: PropTypes.object,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  last: PropTypes.bool
};

export default NavigationCard;
